//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import hTag from './h-tag.vue';
import skuEditorTable from './sku-editor-table.vue';
import util from '@/lib/util';
export default {
    name: "skuEditor",
    props: {
        spec: {
            type: [Array, Object]
        },
        data: {
            type: Array
        },
        separator: {
            type: String,
            default: '_'
        },
        addSpecItem: {
            type: Function
        },
        addSpec: {
            type: Function
        },
        editableColumns: {
            type: Array,
            default: function() {
                return [{ key: "price", title: '价格' },
                    { key: "quantity", title: '库存' }];
            }
        },
        specEditable:{
            type:[Boolean,String],
            default:true
        },
        readonly:{
            type:[Boolean,String],
            default:false
        }
    },
    components: {
        hTag,
        skuEditorTable
    },
    data: function() {
        return {
            specification: {},
            selectedItems: [],
            thisDatas: [],
            loading: false,
            editableDatas: [],
            thisEditableColumns: [],
            mergeDatas: [],
            matrixData: [],
            specDelEabled: []
        };
    },
    created: function() {},
    mounted: function() {
        this.specTranslation();
        this.editableColumnsTransiation();
    },
    computed: {
        columns: function() {
            var self = this;
            var cols = [];
            for (var property1 in self.specification) {
                if (self.specification.hasOwnProperty(property1)) {
                    cols.push({
                        title: property1,
                        key: property1
                    });
                }
            }
            for (let index = 0; index < this.editableColumns.length; index++) {
                const element = this.editableColumns[index];
                cols.push({ title: element.title, key: element.key });
            }
            return cols;
        },
        specTotalCount: function() {
            var count = 0;
            for (var key in this.specification) {
                count += this.specification[key].length;
                count++;
            }
            return count;
        },
        thisSpecEditable:function(){
            return util.string2Boolean(this.specEditable);
        },
        thisReadonly:function(){
            return util.string2Boolean(this.readonly);
        }
    },
    methods: {
        //#region events
        handleRemoveSpecItem: function(item, key) {
            var self = this;
            var index = self.specification[key].indexOf(item);
            self.specification[key].splice(index, 1);
            if (self.spec instanceof Array) {
                self.$emit("on-rmspecitem", self.utilGetFromArrayByKey(self.spec, key, 'text'), item);
            } else {
                self.$emit("on-rmspecitem", key, item);
            }
        },
        handleRemoveSpec: function(key) {
            var self = this;
            if (!self.thisSpecEditable) {
                return false;
            }
            if (self.specification.hasOwnProperty(key)) {
                //delete self.specification[key];
                self.$delete(self.specification, key);
                self.clear();
            }
            if (self.spec instanceof Array) {
                self.$emit("on-rmspec", self.utilGetFromArrayByKey(self.spec, key, 'text'));
            } else {
                self.$emit("on-rmspec", key);
            }
        },

        handleCheck: function($event, value, index) {
            value.checked = $event;
            this.loading = true;
            this.selectedItems[index] = $event ? this.utilPush(this.selectedItems[index], value) : this.utilRemove(
                this.selectedItems[index], value);
            if (this.utilUnEmptyLength(this.selectedItems) === this.utilPropertyCount(this.specification)) {
                this.matrixData = this.calcCombination(this.selectedItems);
                this.combinationData();
            } else {
                this.thisDatas = [];
                this.triggerDataChange();
            }
            this.loading = false;
        },
        handleAddSpecItem: function(key, index) {
            var self = this;
            var thisAddSpecItem = self.addSpecItem;
            var defaultAddSpecItem = () => {
                return new Promise((resolve, reject) => {
                    resolve(self.specTotalCount)
                });
            };
            thisAddSpecItem = thisAddSpecItem || defaultAddSpecItem;
            var value = self.$refs.input[index].currentValue.trim();
            var existsItem = this.utilGetFromArrayByKey(self.specification[key], value, 'text');
            if (existsItem) {
                abp.message.error('规格项[' + value + ']已存在！');
                return;
            }
            if (value && !existsItem) {
                thisAddSpecItem(key, value).then((id) => {
                    self.specification[key].push({ id: id, text: value });
                });
            }
            self.$refs.input[index].setCurrentValue("");
        },
        handleAddSpec: function() {
            var self = this;
            var thisAddSpec = self.addSpec;
            var defaultAddSpec = () => {
                return new Promise((resolve, reject) => {
                    resolve(self.specTotalCount);
                });
            };
            thisAddSpec = thisAddSpec || defaultAddSpec;
            var value = self.$refs.inputcategory.currentValue.trim();
            if (self.specification[value]) {
                abp.message.error('规格类型[' + value + ']已存在！');
                return;
            }
            if (value && !self.specification[value]) {
                thisAddSpec(value).then(() => {
                    self.$set(self.specification, value, new Array());
                    self.clear();
                });
            }
            self.$refs.inputcategory.setCurrentValue("");
        },
        //#endregion

        //#region util
        utilPush: function(array, data, keyproperty) {
            array = array || [];
            keyproperty = keyproperty || 'id';
            var isExists = false;
            for (var i = 0; i < array.length; i++) {
                if (array[i][keyproperty] == data[keyproperty]) {
                    isExists = true;
                    break;
                }
            }
            if (!isExists) {
                array.push(data);
            }
            return array;
        },
        utilRemove: function(array, data, keyproperty) {
            array = array || [];
            keyproperty = keyproperty || 'id';
            var i = 0;
            for (i = 0; i < array.length; i++) {
                if (array[i][keyproperty] == data[keyproperty]) {
                    break;
                }
            }
            if (i !== array.length) {
                array.splice(i, 1);
            }
            return array;
        },
        utilPropertyCount: function(obj) {
            var i = 0;
            for (var key in obj) {
                i++;
            }
            return i;
        },
        utilGetFromArrayByKey: function(array, keyValue, keyName) {
            array = array || [];
            keyName = keyName || 'id';
            for (var i = 0; i < array.length; i++) {
                if (array[i][keyName] == keyValue) {
                    return array[i];
                }
            }
        },
        utilUnEmptyLength: function(array) {
            var length = 0;
            for (var i = 0; i < array.length; i++) {
                if (array[i]) {
                    if (array[i] instanceof Array) {
                        if (array[i].length > 0) {
                            length++;
                        }
                    } else {
                        length++;
                    }
                }
            }
            return length;
        },
        //#endregion
        specTranslation: function() {
            var spec = [];
            if (this.spec !== undefined && this.spec !== null) {
                spec = JSON.parse(JSON.stringify(this.spec));
            }
            this.specification = {};
            var targetSpec = {};
            var getParentName = function(item) {
                for (var i = 0; i < spec.length; i++) {
                    var specItem = spec[i];
                    if (specItem.id === item.parentId) {
                        return specItem.text;
                    }
                }
            };
            if (spec && spec instanceof Array) {
                for (var i = 0; i < spec.length; i++) {
                    var specItem = spec[i];
                    specItem.checked = false;
                    if (specItem.parentId !== undefined && specItem.parentId !== 0) {
                        var parentName = getParentName(specItem);
                        if (parentName) {
                            targetSpec[parentName] = targetSpec[parentName] || [];
                            targetSpec[parentName].push(specItem);
                        }

                    }
                    if (specItem.parentId !== undefined && specItem.parentId === 0) {
                        targetSpec[specItem.text] = [];
                    }
                }
                this.specification = targetSpec;
            } else {
                this.specification = JSON.parse(JSON.stringify(spec));
            }
        },


        calcCombination: function(selectedData) {
            var length = selectedData.length;
            if (length >= 2) {
                var arr1 = selectedData[0];
                var arr2 = selectedData[1];
                var len1 = selectedData[0].length;
                var len2 = selectedData[1].length;
                var newlen = len1 * len2;
                var temp = new Array(newlen);
                var index = 0;
                for (var i = 0; i < len1; i++) {
                    for (var j = 0; j < len2; j++) {
                        temp[index] = {};
                        temp[index]['id'] = arr1[i].id + this.separator + arr2[j].id;
                        temp[index]['text'] = arr1[i].text + this.separator + arr2[j].text;
                        index++;
                    }
                }
                var newArray = new Array(length - 1);
                newArray[0] = temp;
                if (length > 2) {
                    var _count = 1;
                    for (var i = 2; i < length; i++) {
                        newArray[_count] = selectedData[i];
                        _count++;
                    }
                }
                return this.calcCombination(newArray);
            } else {
                return selectedData[0];
            }
        },
        triggerDataChange: function() {
            this.$emit("on-datachange", this.thisDatas);
        },
        isEditable: function(rowIndex, colKey) {
            if(this.thisReadonly){
                return false;
            }
            if (!this.editableDatas[rowIndex]) {
                this.$set(this.editableDatas, rowIndex, {})
            }
            return !!this.editableDatas[rowIndex][colKey];
        },
        enableEdit: function(rowIndex, colKey) {
            if (!this.editableDatas[rowIndex]) {
                this.$set(this.editableDatas, rowIndex, {})
            }
            if (this.thisEditableColumns.indexOf(colKey) < 0) {
                return;
            }
            var orgEditableData = this.editableDatas[rowIndex];
            orgEditableData[colKey] = true;
            this.$set(this.editableDatas, rowIndex, orgEditableData);
            this.$nextTick(() => {
                this.$refs.tableInput[0].focus()
            })
        },
        disableEdit: function(rowIndex, colKey) {
            if (!this.editableDatas[rowIndex]) {
                this.$set(this.editableDatas, rowIndex, {})
            }
            var orgEditableData = this.editableDatas[rowIndex];
            orgEditableData[colKey] = false;
            this.$set(this.editableDatas, rowIndex, orgEditableData);
            this.triggerDataChange();
        },
        combinationData: function() {
            var self = this;
            var combinationResult = self.matrixData;
            var targetDatas = [];
            self.editableDatas = [];
            for (var index in combinationResult) {
                var spec = combinationResult[index];
                var data = { id: spec.id };
                var orgData = self.utilGetFromArrayByKey(self.thisDatas, data.id, 'id');
                if (orgData) {
                    targetDatas.push(orgData);
                    continue;
                }
                var viewData = spec.text.split(self.separator);
                var i = 0;
                for (var key in self.specification) {
                    data[key] = viewData[i];
                    i++;
                }
                for (let index = 0; index < self.editableColumns.length; index++) {
                    const element = self.editableColumns[index];
                    data[element.key] = 0;
                }
                targetDatas.push(data);
            }
            self.thisDatas = targetDatas;
            self.triggerDataChange();
            self.mergeCell(self.thisDatas);
        },
        setChecked: function() {
            var self = this;
            var targetSelectedItems = [];
            for (let index = 0; index < self.thisDatas.length; index++) {
                let element = self.thisDatas[index];
                if (element.id) {
                    var checkedIds = element.id.split(self.separator);
                    for (let idIndex = 0; idIndex < checkedIds.length; idIndex++) {
                        const id = checkedIds[idIndex];
                        var i = 0;
                        for (const key in self.specification) {
                            if (self.specification.hasOwnProperty(key)) {
                                const specItems = self.specification[key];
                                var result = self.utilGetFromArrayByKey(specItems, id, 'id');
                                if (result) {
                                    result.checked = true;
                                    element[key] = result.text;
                                    targetSelectedItems[i] = targetSelectedItems[i] || [];
                                    if (!self.utilGetFromArrayByKey(targetSelectedItems[i], result.id, 'id')) {
                                        targetSelectedItems[i].push(result);
                                    }
                                }
                                i++;
                            }
                        }
                    }
                }
                self.$set(self.thisDatas, index, element);
            }
            self.selectedItems = targetSelectedItems;
            self.matrixData = self.calcCombination(self.selectedItems);
            self.combinationData();
        },
        mergeCell: function(data) {
            this.mergeDatas = [];
            var targetMergeDatas = [];
            var tempdata = {};
            for (let index = 0; index < this.thisDatas.length; index++) {
                const element = this.thisDatas[index];
                var mergeData = {};
                for (var key in this.specification) {
                    if (element[key] === tempdata[key]) {
                        targetMergeDatas[this.getTheLastTimeMerge(targetMergeDatas, key)][key] += 1;
                        mergeData[key] = 0;
                    } else {
                        mergeData[key] = 1;
                    }
                }
                tempdata = element;
                targetMergeDatas.push(mergeData);
            }
            this.mergeDatas = targetMergeDatas;
        },
        getTheLastTimeMerge: function(mergeDatas, key) {
            for (var i = mergeDatas.length - 1; i >= 0; i--) {
                if (mergeDatas[i][key] != 0) {
                    return i;
                }
            }
        },
        getRowSpan: function(rIndex, colKey) {
            this.mergeDatas[rIndex] = this.mergeDatas[rIndex] || {};
            if (this.mergeDatas[rIndex][colKey] === undefined) {
                return 1;
            }
            return this.mergeDatas[rIndex][colKey];
        },
        editableColumnsTransiation: function() {
            var targetEditColumns = [];
            if (this.editableColumns) {
                for (let index = 0; index < this.editableColumns.length; index++) {
                    const element = this.editableColumns[index];
                    targetEditColumns.push(element.key);
                }
                this.thisEditableColumns = targetEditColumns;
            }
        },
        clearCheck: function() {
            for (var key in this.specification) {
                let element = this.specification[key];
                for (let itemIndex = 0; itemIndex < element.length; itemIndex++) {
                    let itemElement = element[itemIndex];
                    itemElement.checked = false;
                }
            }
        },
        clear: function() {
            this.thisDatas = [];
            this.selectedItems = [];
            this.editableDatas = [];
            this.mergeDatas = [];
            this.clearCheck();
            this.matrixData = [];
            this.triggerDataChange();
        },
        reRender: function() {
            this.setChecked();
        }
    },
    watch: {
        editableDatas: function(newValue) {},
        spec: function(newValue, oldValue) {
            this.specTranslation();
            this.$nextTick(function() {
                this.reRender();
            });
        },
        data: function(newValue, oldValue) {
            var newValueText = JSON.stringify(newValue);
            var oldValueText = JSON.stringify(this.thisDatas);
            if (newValueText !== oldValueText) {
                this.thisDatas = JSON.parse(JSON.stringify(newValue));
                if (this.specification && JSON.stringify(this.specification) !== '{}') {
                    this.reRender();
                }
            }
        },
        editableColumns: function(newValue) {
            this.editableColumnsTransiation();
        }
    }
}

